import React from "react";
import { Card, Form } from "antd";
import ImageUploader from "components/shared-components/ImageUploader";

export const PhotoUploadCard = ({ imgUrlDisplay, imgUrl, onChangeImage }) => {
  return (
    <Card>
      <img
        src={
          imgUrlDisplay ||
          "https://api.banyuasinkab.info/uploads/1750945134485-dummy-image.jpg"
        }
        alt="Preview Foto"
        style={{ width: "100%" }}
      />
      <br></br>
      <h3>Ubah Foto Profil</h3>
      <Form.Item label="Foto Profil" name="photo">
        <ImageUploader imageUrl={imgUrl} onChange={onChangeImage} />
      </Form.Item>
    </Card>
  );
};
